// Ștampilă circulară "Made in Pașcani"
export const MadeInStamp = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} data-testid="made-in-stamp">
    <defs>
      <path id="mip-circle" d="M50,50 m-34,0 a34,34 0 1,1 68,0 a34,34 0 1,1 -68,0" />
    </defs>
    <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.55" />
    <circle cx="50" cy="50" r="36" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.55" />
    <text fontSize="9.5" fontWeight="700" letterSpacing="1.4" fill="currentColor">
      <textPath href="#mip-circle" startOffset="0">MADE IN PAȘCANI · 100% LOCAL · </textPath>
    </text>
    <text x="50" y="48" textAnchor="middle" fontSize="16" fontWeight="800" fill="currentColor" className="font-display">VLY</text>
    <text x="50" y="62" textAnchor="middle" fontSize="6.5" letterSpacing="2" fill="currentColor">DRIVE</text>
  </svg>
);

export default MadeInStamp;
